import React from "react";
import { MapPin, Phone, Mail, Linkedin, Facebook } from "lucide-react";
import { COMPANY } from "../mock/mock";

const TopBar = () => {
  return (
    <div className="w-full bg-[#0f2740] text-white/85 text-[13px]">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-2.5 flex flex-col md:flex-row items-center justify-between gap-2">
        <div className="hidden lg:flex items-center gap-2">
          <MapPin size={15} className="text-[#9bc3e6]" />
          <span>{COMPANY.address}</span>
        </div>
        <div className="flex items-center gap-5">
          <a href={`tel:${COMPANY.phoneHref}`} className="flex items-center gap-2 hover:text-white transition-colors">
            <Phone size={15} className="text-[#9bc3e6]" />
            <span>{COMPANY.phone}</span>
          </a>
          <a href={`mailto:${COMPANY.email}`} className="flex items-center gap-2 hover:text-white transition-colors">
            <Mail size={15} className="text-[#9bc3e6]" />
            <span className="hidden sm:inline">{COMPANY.email}</span>
          </a>
          <div className="flex items-center gap-3 pl-2 border-l border-white/15">
            <a href={COMPANY.social.facebook} target="_blank" rel="noreferrer" className="hover:text-[#9bc3e6] transition-colors" aria-label="Facebook">
              <Facebook size={16} />
            </a>
            <a href={COMPANY.social.linkedin} target="_blank" rel="noreferrer" className="hover:text-[#9bc3e6] transition-colors" aria-label="LinkedIn">
              <Linkedin size={16} />
            </a>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TopBar;
